import { Box, TextField, Typography, Link } from "@mui/material";
import React, { useEffect } from "react";
import SyncFrequencySelect from "../components/SyncFrequencySelect";

interface NotionIntegrationFormProps {
  editMode?: boolean;
  initialData?: {
    syncFrequency?: string;
    integrationSecret?: string;
  };
  onValidationChange: (isValid: boolean) => void;
  onDataChange: (data: { syncFrequency: string; integrationSecret: string }) => void;
}

export default function NotionIntegrationForm({
  editMode = false,
  initialData = {},
  onValidationChange,
  onDataChange,
}: NotionIntegrationFormProps) {
  const [syncFrequency, setSyncFrequency] = React.useState(
    initialData.syncFrequency || "manual"
  );
  const [integrationSecret, setIntegrationSecret] = React.useState(
    initialData.integrationSecret || ""
  );

  // Update parent with current data
  useEffect(() => {
    onDataChange({
      syncFrequency,
      integrationSecret,
    });
  }, [syncFrequency, integrationSecret, onDataChange]);

  // Validate that integration secret is provided
  useEffect(() => {
    const isValid = integrationSecret.trim().length > 0;
    onValidationChange(isValid);
  }, [integrationSecret, onValidationChange]);

  return (
    <Box sx={{ mt: 2 }}>
      <Typography variant="body2" sx={{ mb: 2, color: "text.secondary" }}>
        To connect Notion, you'll need to create an internal integration in your Notion workspace.{" "}
        <Link 
          href="https://developers.notion.com/docs/create-a-notion-integration" 
          target="_blank" 
          rel="noopener noreferrer"
        >
          Learn how to create a Notion integration
        </Link>
      </Typography>
      
      <TextField
        fullWidth
        label="Internal Integration Secret"
        placeholder="secret_..."
        value={integrationSecret}
        onChange={(e) => setIntegrationSecret(e.target.value)}
        required
        helperText="Enter your Notion internal integration secret token"
        sx={{ mb: 2 }}
        type="password"
      />
      
      <SyncFrequencySelect
        value={syncFrequency}
        onChange={setSyncFrequency}
        sx={{ mt: 2 }}
      />
    </Box>
  );
}